import React from 'react'

const Loader = () => {
  return (
    <div className='bg-black text-white-100'>Yükleniyor...</div>
  )
}

export default Loader